import isMultiDomain from './isMultiDomain';
import getUserId from './session/getUserId';
import { getIsAssetEditableInHub } from './privileges';
import { checkIsAsset } from 'types/content/utils';
export default function checkIsEditableAsset(_ref) {
  var _contentItem$author;
  var contentItem = _ref.contentItem,
    _ref$allowEditingDist = _ref.allowEditingDistributedAssets,
    allowEditingDistributedAssets = _ref$allowEditingDist === void 0 ? false : _ref$allowEditingDist;
  var isAsset = checkIsAsset(contentItem);
  if (!isAsset) return false;
  if (!allowEditingDistributedAssets) {
    var isAssetDistributed = isMultiDomain(contentItem);
    if (isAssetDistributed) {
      return false;
    }
  }
  var isContributingUserAuthor = getUserId() === ((_contentItem$author = contentItem.author) === null || _contentItem$author === void 0 ? void 0 : _contentItem$author.id);
  return getIsAssetEditableInHub({
    ownerTeamId: contentItem.ownerTeamId,
    domain_id: contentItem.domain_id,
    allowEditingDistributedPlaylists: allowEditingDistributedAssets
  }) || isContributingUserAuthor;
}